import { z } from "zod";

export const addEOCSchema = z.object({
  selectedConditionCode: z.string(),
});
